require("@rails/ujs").start()
require("turbolinks").start()

import { Application } from "stimulus"
import AutoPrintController from "controllers/auto_print_controller"
import MapTooltipController from "controllers/map_tooltip_controller"
import NumberAnimationController from "controllers/number_animation_controller"
import PublicReportSearchController from "controllers/public_report_search_controller"
import SubmitController from "controllers/submit_controller"
import TableFilterController from "controllers/table_filter_controller"
import "../styles/public_report_application.scss"

const application = Application.start()

application.register("auto-print", AutoPrintController)
application.register("map-tooltip", MapTooltipController)
application.register("number-animation", NumberAnimationController)
application.register("public-report-search", PublicReportSearchController)
application.register("submit", SubmitController)
application.register("table-filter", TableFilterController)
